export const productCategoriesChild = [
    {
        categoryFilter: 'rings',
        categoryChildren: [
            {
                recommended: {
                    recommend: 'Recommended for you',
                    recommend_img: '',
                    url: '',
                },
                shopByStyle: [
                    {
                        shopByStyleTitle: 'shop by style'
                    },
                    {
                        catTitle: 'Engagement',
                        catImage: '',
                        catUrl: '',
                    },
                    {
                        catTitle: 'Couple Bands',
                        catImage: '',
                        catUrl: '',
                    },
                    {
                        catTitle: 'Religious',
                        catImage: '',
                        catUrl: '',
                    },
                    {
                        catTitle: 'Eternity',
                        catImage: '',
                        catUrl: '',
                    },
                    {
                        catTitle: 'Casual',
                        catImage: '',
                        catUrl: '',
                    },
                    {
                        catTitle: 'Flexi/Adjustable',
                        catImage: '',
                        catUrl: '',
                    },
                    {
                        catTitle: 'V rings/Chevron',
                        catImage: '',
                        catUrl: '',
                    },
                    {
                        catTitle: 'Navratna',
                        catImage: '',
                        catUrl: '',
                    },
                    {
                        catTitle: 'Stackable',
                        catImage: '',
                        catUrl: '',
                    },
                    {
                        catTitle: 'Mangalsutra',
                        catImage: '',
                        catUrl: '',
                    },
                ],
                shopByMaterial: [
                    {
                        shopByMaterialTitle: 'shop by Material'
                    },
                    {
                        catTitle: 'Diamond',
                        catImage: '',
                        catUrl: '',
                    },
                    {
                        catTitle: 'Platinum',
                        catImage: '',
                        catUrl: '',
                    },
                    {
                        catTitle: 'Gemstone',
                        catImage: '',
                        catUrl: '',
                    },
                    {
                        catTitle: 'Gold',
                        catImage: '',
                        catUrl: '',
                    },
                ],
                shopByPrice: [
                    {
                        shopByPriceTitle: 'shop by price'
                    },
                    {
                        catTitle: 'Under ₹10K',
                        catUrl: '',
                    },
                    {
                        catTitle: '₹10K - ₹20K',
                        catUrl: '',
                    },
                    {
                        catTitle: '₹20K - ₹30K',
                        catUrl: '',
                    },
                    {
                        catTitle: '₹30K - ₹50K',
                        catUrl: '',
                    },
                    {
                        catTitle: '₹50K - ₹75K',
                        catUrl: '',
                    },
                    {
                        catTitle: 'Above ₹75K',
                        catUrl: '',
                    },
                ],
                shopByOcassion: [
                    {
                        shopByOcassionTitle: 'shop by occasion'
                    },
                    {
                        catTitle: 'Daily wear',
                        catImage: '',
                        catUrl: '',
                    },
                    {
                        catTitle: 'Casual Outings',
                        catImage: '',
                        catUrl: '',
                    },
                    {
                        catTitle: 'Anniversary',
                        catImage: '',
                        catUrl: '',
                    },
                    {
                        catTitle: 'Festive',
                        catImage: '',
                        catUrl: '',
                    },
                    {
                        catTitle: 'Wedding',
                        catImage: '',
                        catUrl: '',
                    },
                ],
                viewAll: {
                    viewAllTitle: 'View All Rings',
                    url: '',
                }
            }
        ]
    },
    {
        categoryFilter: 'earrings',
        categoryChildren: [
            {
                recommended: {
                    recommend: 'Recommended for you',
                    recommend_img: '',
                    url: '',
                },
                shopByStyle: [
                    {
                        shopByStyleTitle: 'shop by style'
                    },
                    {
                        catTitle: 'Engagement',
                        catImage: '',
                        catUrl: '',
                    },
                    {
                        catTitle: 'Couple Bands',
                        catImage: '',
                        catUrl: '',
                    },
                    {
                        catTitle: 'Religious',
                        catImage: '',
                        catUrl: '',
                    },
                    {
                        catTitle: 'Eternity',
                        catImage: '',
                        catUrl: '',
                    },
                    {
                        catTitle: 'Casual',
                        catImage: '',
                        catUrl: '',
                    },
                    {
                        catTitle: 'Flexi/Adjustable',
                        catImage: '',
                        catUrl: '',
                    },
                    {
                        catTitle: 'V rings/Chevron',
                        catImage: '',
                        catUrl: '',
                    },
                    {
                        catTitle: 'Navratna',
                        catImage: '',
                        catUrl: '',
                    },
                    {
                        catTitle: 'Stackable',
                        catImage: '',
                        catUrl: '',
                    },
                    {
                        catTitle: 'Mangalsutra',
                        catImage: '',
                        catUrl: '',
                    },
                ],
                shopByMaterial: [
                    {
                        shopByMaterialTitle: 'shop by Material'
                    },
                    {
                        catTitle: 'Diamond',
                        catImage: '',
                        catUrl: '',
                    },
                    {
                        catTitle: 'Platinum',
                        catImage: '',
                        catUrl: '',
                    },
                    {
                        catTitle: 'Gemstone',
                        catImage: '',
                        catUrl: '',
                    },
                    {
                        catTitle: 'Gold',
                        catImage: '',
                        catUrl: '',
                    },
                ],
                shopByPrice: [
                    {
                        shopByPriceTitle: 'shop by price'
                    },
                    {
                        catTitle: 'Under ₹10K',
                        catUrl: '',
                    },
                    {
                        catTitle: '₹10K - ₹20K',
                        catUrl: '',
                    },
                    {
                        catTitle: '₹20K - ₹30K',
                        catUrl: '',
                    },
                    {
                        catTitle: '₹30K - ₹50K',
                        catUrl: '',
                    },
                    {
                        catTitle: '₹50K - ₹75K',
                        catUrl: '',
                    },
                    {
                        catTitle: 'Above ₹75K',
                        catUrl: '',
                    },
                ],
                shopByOcassion: [
                    {
                        shopByOcassionTitle: 'shop by occasion'
                    },
                    {
                        catTitle: 'Daily wear',
                        catImage: '',
                        catUrl: '',
                    },
                    {
                        catTitle: 'Casual Outings',
                        catImage: '',
                        catUrl: '',
                    },
                    {
                        catTitle: 'Anniversary',
                        catImage: '',
                        catUrl: '',
                    },
                    {
                        catTitle: 'Festive',
                        catImage: '',
                        catUrl: '',
                    },
                    {
                        catTitle: 'Wedding',
                        catImage: '',
                        catUrl: '',
                    },
                ],
                viewAll: {
                    viewAllTitle: 'View All Earrings',
                    url: '',
                }
            }
        ]
    }
]